import styled from '@emotion/styled';

export const StateCard = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: theme.spacing[16],
  padding: theme.spacing[40],
  borderRadius: theme.radius[16],
  backgroundColor: theme.colors.background.raised,
}));

export const Centered = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  padding: `${theme.spacing[40]}px 0`,
}));

export const TableWrapper = styled('div')(({ theme }) => ({
  marginTop: theme.spacing[16],
}));
